/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  formLabel,
  formInputText,
  formControl,
  formControlContainer,
  formControlError,
} from '@assets/styles/formStyles';
import { getAttibutes } from '@global/helpers';
import { INPUT_HEIGHT } from '@/constants';
import SociollaText from '@components/sociolla/SociollaText';
import PropTypes from 'prop-types';

const propTypes = {
  inputValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  hasError: PropTypes.bool,
  editable: PropTypes.bool,
  containerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  editable: true,
  containerStyle: {},
  inputContainerStyle: {},
  hasError: false,
  inputValue: '',
};

const FormInputVariant = (props) => {
  const {
    editable,
    containerStyle,
    inputContainerStyle,
    hasError,
    inputValue,
  } = props;

  return (
    <View style={[{ marginTop: 10 }, formControlContainer, containerStyle]}>
      <SociollaText style={formLabel}>Variant</SociollaText>
      <View
        style={[
          formControl,
          inputContainerStyle,
          hasError ? formControlError : {},
          !editable ? { backgroundColor: '#ebebeb' } : {},
          styles.formInput,
        ]}>
        <SociollaText style={formInputText}>
          {inputValue?.variant
            ? inputValue.variant
            : inputValue.combination?.variant
            ? inputValue.combination.variant
            : getAttibutes(inputValue.combination.attributes)}
        </SociollaText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  formInput: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    height: INPUT_HEIGHT,
  },
});

FormInputVariant.propTypes = propTypes;
FormInputVariant.defaultProps = defaultProps;

export default React.memo(FormInputVariant, (prev, next) => prev == next);
